import { createFileRoute } from '@tanstack/react-router'
import { requireCapability } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { reportRangeSearchSchema } from '@/features/reports/components/report-range-search'
import { ProfitabilityPage } from '@/features/reports/pages/profitability'

import type { ReportRangeSelection } from '@/types'

export const Route = createFileRoute('/_dashboard/analytics/profitability')({
  beforeLoad: requireCapability('VIEW_REPORTS'),
  validateSearch: reportRangeSearchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ProfitabilityRoute,
})

function ProfitabilityRoute() {
  const selection = Route.useSearch()
  const navigate = Route.useNavigate()
  const onSelectionChange = (next: ReportRangeSelection) => navigate({ search: next, replace: true })
  return <ProfitabilityPage selection={selection} onSelectionChange={onSelectionChange} />
}
